module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Mezzi_di_Lavoro_in_Azione-BN.70cb2c99.svg";